/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Outbound_DeliveryInputs */

const en_field_outbound_delivery = /** @type {(inputs: Field_Outbound_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outbound delivery`)
};

/**
* | output |
* | --- |
* | "Outbound delivery" |
*
* @param {Field_Outbound_DeliveryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_outbound_delivery = /** @type {((inputs?: Field_Outbound_DeliveryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Outbound_DeliveryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_outbound_delivery(inputs)
});